import { render, staticRenderFns } from "./DefaultTableActions.vue?vue&type=template&id=60f2eeb0&"
import script from "./DefaultTableActions.vue?vue&type=script&lang=ts&"
export * from "./DefaultTableActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports